<template>
    <template v-if="type == 'nav-superiore'">
        <a v-if="!item.children?.length && item.FLG_TIPOLOGIA == 1 && (item.FK_ID_LIVELLO == this.$root.utente.FK_ID_LIVELLO || item.FK_ID_LIVELLO == 0) && this.$root.isMenuItemVisibile(item)" href="#" class="dropdown-item" @click.prevent="$emit('route-click', item.ROUTE || '#')" >
            <div v-html="item.ICONA"></div><span class="text-muted me-1">|</span>{{ item.DESCRIZIONE }}
        </a>
        <div v-else-if="item.children.length > 0 && item.FLG_TIPOLOGIA == 1 && (item.FK_ID_LIVELLO == this.$root.utente.FK_ID_LIVELLO || item.FK_ID_LIVELLO == 0) && this.$root.isMenuItemVisibile(item)" class="dropdown-submenu" :class="{ show: open }">
            <a v-if="item.FLG_TIPOLOGIA == 1" href="#" class="dropdown-item dropdown-toggle" :class="{ show: open }" @click.prevent="toggle()">
                <div v-html="item.ICONA"></div>
                <span class="text-muted me-1">|</span>
                {{ item.DESCRIZIONE }}
            </a>
            <div v-else class="dropdown-divider"></div>
            <div class="dropdown-menu" :class="{ show: open }">
                <SubMenu
                    v-for="child in item.children"
                    :key="child.ID_MENU"
                    :item="child"
                    :type="type"
                    @route-click="onRouteClick">
                </SubMenu>
            </div>
        </div>
        <div v-else-if="item.FLG_TIPOLOGIA == 3 && (item.FK_ID_LIVELLO == this.$root.utente.FK_ID_LIVELLO || item.FK_ID_LIVELLO == 0) && this.$root.isMenuItemVisibile(item)" class="dropdown-header text-uppercase fw-bold fs-sm">{{ item.DESCRIZIONE }}</div>
        <div v-else-if="item.FLG_TIPOLOGIA == 0 && (item.FK_ID_LIVELLO == this.$root.utente.FK_ID_LIVELLO || item.FK_ID_LIVELLO == 0) && this.$root.isMenuItemVisibile(item)" class="dropdown-divider"></div>
    </template>

    <template v-else-if="type === 'nav-laterale'">
        <li v-if="item.FLG_TIPOLOGIA == 3 && (item.FK_ID_LIVELLO == this.$root.utente.FK_ID_LIVELLO || item.FK_ID_LIVELLO == 0) && this.$root.isMenuItemVisibile(item)" class="nav-item-header">
            <div class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide">{{ item.DESCRIZIONE }}</div>
            <i class="ph-dots-three sidebar-resize-show"></i>
        </li>
        <li v-else class="nav-item" :class="{'nav-item-submenu': item.children?.length, 'nav-item-open': open && item.children?.length}">
            <a v-show="(item.FK_ID_LIVELLO == this.$root.utente.FK_ID_LIVELLO || item.FK_ID_LIVELLO == 0) && this.$root.isMenuItemVisibile(item)" href="#" class="nav-link" @click.prevent="item.children?.length ? toggle() : $emit('route-click', item.ROUTE || '#')">
                <div v-html="item.ICONA"></div><span>{{ item.DESCRIZIONE }}</span>
            </a>
            <ul v-if="item.children?.length" class="nav-group-sub collapse" :class="{ show: open }">
                <SubMenu
                    v-for="child in item.children"
                    :key="child.ID_ITEM"
                    :item="child"
                    :type="type"
                    @route-click="onRouteClick">
                </SubMenu>
            </ul>
        </li>
    </template>

</template>
  
<script>
export default {

    name: 'SubMenu',

    emits: ['route-click'],

    props: {
        item: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            default: 'nav-superiore',
        },
    },

    data() {
        return {
            open: false
        };
    },

    methods: {
        onRouteClick(route) {
            this.$emit('route-click', route)
        },
        toggle() {
            this.open = !this.open;
        }
    }

  }
</script>
  